(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer-1"]) return;
  try {
    
  	(function ($) {
      jQuery(document).ready(function($) {
    	$('#newsletter_form .alert-success').hide();
    	// CHECK FORM POSTED
    	$('.contact-form').each(function (){
    	$(this).on('submit', function(e){
    	var formCookie = $(this).attr('class');
    	$.cookie('formSended', formCookie); 
    	});
    	});
    	
    	if( document.location.href.indexOf('?customer_posted=true') > 0 && $.cookie('formSended') == 'contact-form') {
    	$('#newsletter_form .form-wrapper').hide();
    	$('#newsletter_form .newsletter-description').hide();
    	$('#newsletter_form .alert-success').show();
    	};
    
    	// FORM VALIDATION
    	$('#newsletter_form').formValidation(); 
         });
  })(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-2"]) return;
  try {
    
  	(function ($) {
      jQuery(document).ready(function($) {
    	$('#newsletter_form .alert-success').hide();
    	// CHECK FORM POSTED
    	$('.contact-form').each(function (){
    	$(this).on('submit', function(e){
    	var formCookie = $(this).attr('class');
    	$.cookie('formSended', formCookie); 
    	});
    	});
    	
    	if( document.location.href.indexOf('?customer_posted=true') > 0 && $.cookie('formSended') == 'contact-form') {
    	$('#newsletter_form .form-wrapper').hide();
    	$('#newsletter_form .newsletter-description').hide();
    	$('#newsletter_form .alert-success').show();
    	};
    
    	// FORM VALIDATION
    	$('#newsletter_form').formValidation(); 
         });
  })(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-3"]) return;
  try {
    
  	(function ($) {
      jQuery(document).ready(function($) {
    	$('#newsletter_form .alert-success').hide();
    	// CHECK FORM POSTED
    	$('.contact-form').each(function (){
    	$(this).on('submit', function(e){
    	var formCookie = $(this).attr('class');
    	$.cookie('formSended', formCookie); 
    	});
    	});
    	
    	if( document.location.href.indexOf('?customer_posted=true') > 0 && $.cookie('formSended') == 'contact-form') {
    	$('#newsletter_form .form-wrapper').hide();
    	$('#newsletter_form .newsletter-description').hide();
    	$('#newsletter_form .alert-success').show();
    	};
    
    	// FORM VALIDATION
    	$('#newsletter_form').formValidation(); 
         });
  })(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-4"]) return;
  try {
    
  	(function ($) {
      jQuery(document).ready(function($) {
    	$('#newsletter_form .alert-success').hide();
    	// CHECK FORM POSTED
    	$('.contact-form').each(function (){
    	$(this).on('submit', function(e){
    	var formCookie = $(this).attr('class');
    	$.cookie('formSended', formCookie); 
    	});
    	});
    	
    	if( document.location.href.indexOf('?customer_posted=true') > 0 && $.cookie('formSended') == 'contact-form') {
    	$('#newsletter_form .form-wrapper').hide();
    	$('#newsletter_form .newsletter-description').hide();
    	$('#newsletter_form .alert-success').show();
    	};
    
    	// FORM VALIDATION
    	$('#newsletter_form').formValidation(); 
         });
  })(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-5"]) return;
  try {
    
  	(function ($) {
      jQuery(document).ready(function($) {
    	$('#newsletter_form .alert-success').hide();
    	// CHECK FORM POSTED
    	$('.contact-form').each(function (){
    	$(this).on('submit', function(e){
    	var formCookie = $(this).attr('class');
    	$.cookie('formSended', formCookie); 
    	});
    	});
    	
    	if( document.location.href.indexOf('?customer_posted=true') > 0 && $.cookie('formSended') == 'contact-form') {
    	$('#newsletter_form .form-wrapper').hide();
    	$('#newsletter_form .newsletter-description').hide();
    	$('#newsletter_form .alert-success').show();
    	};
    
    	// FORM VALIDATION
    	$('#newsletter_form').formValidation(); 
         });
  })(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
  constructor() {
  super();
  this.elements = {
  input: this.querySelector('input[name="currency_code"]'),
  button: this.querySelector('button'),
  panel: this.querySelector('ul'),
  };
  this.elements.button.addEventListener('click', this.openSelector.bind(this));
  this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
  this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
  
  this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }
  
  hidePanel() {
  this.elements.button.setAttribute('aria-expanded', 'false');
  this.elements.panel.setAttribute('hidden', true);
  }
  
  onContainerKeyUp(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;
  
  this.hidePanel();
  this.elements.button.focus();
  }
  
  onItemClick(event) {
  event.preventDefault();
  const form = this.querySelector('form');
  this.elements.input.value = event.currentTarget.dataset.value;
  if (form) form.submit();
  }
  
  openSelector() {
  this.elements.button.focus();
  this.elements.panel.toggleAttribute('hidden');
  this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
  }
  
  closeSelector(event) {
  const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
  if (event.relatedTarget === null || shouldClose) {
  this.hidePanel();
  }
  }
  }
  
  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header_sidebar"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
  constructor() {
  super();
  this.elements = {
  input: this.querySelector('input[name="currency_code"]'),
  button: this.querySelector('button'),
  panel: this.querySelector('ul'),
  };
  this.elements.button.addEventListener('click', this.openSelector.bind(this));
  this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
  this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
  
  this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }
  
  hidePanel() {
  this.elements.button.setAttribute('aria-expanded', 'false');
  this.elements.panel.setAttribute('hidden', true);
  }
  
  onContainerKeyUp(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;
  
  this.hidePanel();
  this.elements.button.focus();
  }
  
  onItemClick(event) {
  event.preventDefault();
  const form = this.querySelector('form');
  this.elements.input.value = event.currentTarget.dataset.value;
  if (form) form.submit();
  }
  
  openSelector() {
  this.elements.button.focus();
  this.elements.panel.toggleAttribute('hidden');
  this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
  }
  
  closeSelector(event) {
  const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
  if (event.relatedTarget === null || shouldClose) {
  this.hidePanel();
  }
  }
  }
  
  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-banners-carousel"] && !Shopify.designMode) return;
  try {
    
jQuery(document).ready(function($) {
	$('.banners-carousel').each(function(i) {

		var sliderId = '#' + $(this).attr('id');
		var sliderVar = $(this).attr('id');
		var sliderPagination = '#pagination_' + sliderVar.replace('banners_carousel_', '');

		var carouselVar = new Swiper( sliderId, {
			effect: 'slide',
			slidesPerView: 1,
			spaceBetween: 10,
			speed: 500,
			autoplayDisableOnInteraction: false,
			pagination: {
				el: sliderPagination,
				type: 'bullets',
				clickable: true,
			},
			navigation: {
				nextEl: $(this).parent().parent().find('.swiper-button-next'),
				prevEl: $(this).parent().parent().find('.swiper-button-prev')
			},
			breakpoints: {
				576: {
					slidesPerView: 2,
					spaceBetween: 15
				},
				768: {
					slidesPerView: 3,
					spaceBetween: 30
				},
				1200: {
					spaceBetween: 30,
					slidesPerView: parseInt($(this).attr('data-slides-per-view')) || 3
				}
			}
		});
	});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-gallery"] && !Shopify.designMode) return;
  try {
    
jQuery(document).ready(function($) {
setTimeout(function(i) {
$('.gallery_carousel').each(function(i) {
var galleryId = '#' + $(this).attr('id');
var galleryVar = $(this).attr('id');
var pagination = '#' + $(this).attr('id').replace('gallery_carousel_','pagination_');


var carouselGalleryVar = new Swiper( galleryId, {
effect: 'slide',
slidesPerView: 3,
spaceBetween: 40,
speed: 500,
observer: true,
observeParents: true,
autoplay: {
disableOnInteraction: false,
},
breakpoints: {
576: {
slidesPerView: 1,
spaceBetween: 0
},
768:{
slidesPerView: 2,
spaceBetween: 20
},
1200: {
slidesPerView: 3,
spaceBetween: 40
}
},
pagination: {
el: '.swiper_pagination',
type: 'bullets',
clickable: true
}
});
});
}, 1000);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-image-with-text-overlay"] && !Shopify.designMode) return;
  try {
    
  jQuery(function($){
  zmzParallax = function() {
  $('.parallax_block-js').each(function() {
  var parallaxBlock = $(this);
  
  var parallaxLayer = $(this).find('.parallax_layer-js');
  
  window.addEventListener('scroll', function() {
  var parallaxHeight = parseInt(parallaxBlock.outerHeight());
  var parallaxImgHeight = parseInt(parallaxLayer.outerHeight());
  
  var parallaxOffset1 = parseInt( parallaxBlock.offset().top);
  var parallaxOffset2 = parseInt( parallaxOffset1 + parallaxHeight );
  
  var translateMax = parseInt( parallaxImgHeight - parallaxHeight ) - 2; // minus 2 to prevent floated numbers and borders between sections
  
  var scrollTemp = $(window).scrollTop() + window.innerHeight;
  
  if ( ( scrollTemp >= parallaxOffset1 ) && ( $(window).scrollTop() <= parallaxOffset2 ) ) {
  // var translateZMZ = parallaxHeight/parallaxImgHeight;
  
  // if ( translateZMZ > 0.2 ) {
  //    var translateVal = parseInt( ( scrollTemp - parallaxOffset1 ) * 0.2 );
  // }
  // else {
  //    var translateVal = parseInt( ( scrollTemp - parallaxOffset1 ) * translateZMZ );
  // };
  
  var translateVal = parseInt( ( scrollTemp - parallaxOffset1 ) * 0.3 );
  var translateVal_2 = parseInt( ( scrollTemp - parallaxOffset1 ) * 0.1 );
  
  if ( translateVal <= translateMax ) {
  parallaxLayer.css({ 'transform' : 'translate3d(0, -' + translateVal + 'px, 0)' });
  }
  else if ( translateVal > translateMax ) {
  parallaxLayer.css({ 'transform' : 'translate3d(0, -' + translateMax + 'px, 0)' });
  };
  };
  });
  });
  };
  if ( $(window).width() > 1199 ) {
  zmzParallax();
  }
  
  $(document).on('shopify:section:load shopify:section:unload', '.section_image-with-text-overlay', function() {
  if ( $(window).width() > 1199 ) {
  zmzParallax();
  }
  });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-logo-list"] && !Shopify.designMode) return;
  try {
    
jQuery(document).ready(function($) {
    $('.logo-swiper').each(function(i) {

        var sliderId = '#' + $(this).attr('id');


        var swiperVar = new Swiper( sliderId, {
            speed: 500,
            effect: 'slide',
            slidesPerView: 2,
            slidesPerColumn: 1,
            navigation: {
                 nextEl: $(this).parent().find('.swiper-button-next'),
                 prevEl: $(this).parent().find('.swiper-button-prev')
            },
            breakpoints: {
                576: {
                    slidesPerView: 3
                },
                768: {
                    slidesPerView: 4
                },
                1200: {
                    slidesPerView: 6
                }
            }
        });
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-lookbook-carousel"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function() {
	  SwiperCarousel();
	  
	  if (Shopify.designMode) {
		  $(document)
			  .on('shopify:section:load', SwiperCarousel)
			  .on('shopify:section:unload', SwiperCarousel)
			  .on('shopify:section:select', SwiperCarousel)
			  .on('shopify:section:deselect', SwiperCarousel)
			  .on('shopify:section:reorder', SwiperCarousel)
			  .on('shopify:block:select', SwiperCarousel)
			  .on('shopify:block:deselect', SwiperCarousel);
	  }
  
	  function SwiperCarousel() {
		  $('.item-lookbook-carousel').each(function () {
			  $('.lb_products_carousel').each(function () {
				  var lbSliderId = '#' + $(this).attr('id');
				  var spotPagWrap = $(this).parent().siblings().find('.lookbook_item_wrap');
  
				  var lbSwiper = new Swiper (lbSliderId, {
					  spaceBetween: 0,
					  slidesPerView: 1,
					  effect: 'fade',
					  fadeEffect: {
						  crossFade: true
					  },
					  loop: true,
					  navigation: {
						  nextEl: '.swiper-button-next',
						  prevEl: '.swiper-button-prev'
					  },
  
					  on: {
						  transitionEnd: function() {
							  spotPagWrap.each(function () {
								  var spotItem = $(this).find(".lookbook_item");
  
								  spotItem.on('mouseover', function(){
									  var target = $(this).data('index');
									  lbSwiper.slideTo(target);
									  return;
								  });
  
								  spotItem.hover(function() {
									  spotItem.removeClass("active");
									  $(this).addClass("active");
								  });
  
								  spotItem.removeClass('active');
								  var active_lbSlide = $(this).parent().siblings().find('.swiper-slide-active').attr('data-class');
								  $(this).find('.lookbook_item[data-class = '+active_lbSlide+']').addClass('active');
							  });
						  }
					  }
				  });
			  });
		  });
	  }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-lookbook"] && !Shopify.designMode) return;
  try {
    
	(function ($) {
	  // button popover clicked
	  window.openPopover = function openPopover(event, popoverID) {
        let element = event.target;
        while (element.nodeName !== "BUTTON") {
            element = element.parentNode;
        }
        Popper.createPopper(element, document.getElementById(popoverID), {
            placement: "auto",
            modifiers: [
                {
                    name: "offset",
                    options: {
                        offset: [0, 6]
                    }
                },
                {
                    name: "flip",
                    options: {
                        allowedAutoPlacements: ["left", "right", "top", "bottom"],
                        rootBoundary: "viewport"
                    }
                }
            ]
        });
        element.classList.toggle("is-active");
        document.getElementById(popoverID).classList.toggle("hidden");
        document.getElementById(popoverID).classList.toggle("is-open");
    }


	  // Hide content popup after clicked outside target
	  $('body').on('click', function (e) {
            let elBul = $("[data-toggle='popover']");
            let elActiveBul = $("[data-toggle='popover'].is-active");
            elActiveBul.each(function () {
                let elemThis = $(this);
                // hide any open popovers when the anywhere else in the body is clicked
                if (!elemThis.is(e.target) && !elBul.is(e.target) && elemThis.has(e.target).length === 0 && $('.lookbook_item__caption.is-open').has(e.target).length === 0) {
                    elemThis.click();
                    elemThis.removeClass('is-active');
                }
            });
        });

        // Behavior slide in custom panel (slide is dependence from block)
        if (Shopify.designMode) {
            $(document)
                .on('shopify:section:unload', change_slide_event)
                .on('shopify:section:select', change_slide_event)
                .on('shopify:section:deselect', change_slide_event)
                .on('shopify:section:reorder', change_slide_event)
                .on('shopify:block:select', change_slide_event)
                .on('shopify:block:deselect', change_slide_event);

            function change_slide_event(evt) {
                const block = evt.target;
                const index = Number(block.dataset.slide);
                const blockSelectedIsSwiperSlide = block.classList.contains('swiper-slide');
                if (!blockSelectedIsSwiperSlide) return;

                var selectedSlideId = $(block).attr("data-block-id");
                var sliderLbSectionID = $(block).closest('.zmz-swiper-container').data('slider-id');

                if (evt.detail.blockId === selectedSlideId) {
                    $("#zmz-carousel-" + sliderLbSectionID + " .swiper-pagination :eq(" + index + ")").click();
                }
            }
        }
   })(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-map"] && !Shopify.designMode) return;
  try {
    
jQuery(document).ready(function($) {
	$.getScript('//maps.googleapis.com/maps/api/js?key=' + theme.mapKey).then(function() {

		$('.section_map').each(function(i) {

			var mapId = $(this).data('section');
			var mapBlock = 'map_' + mapId;

			var mapAddress = $(this).data('map-address');
			var mapMarker = $(this).data('map-marker');
			var mapStyle = $(this).data('map-style');

			var mapLoad = function(mapAddress, mapMarker, mapStyle) {

				var latlng = new google.maps.LatLng(0, 0);

				var mapOptions = {
					center: latlng,
					zoom: 15,
					mapTypeId: google.maps.MapTypeId.ROADMAP,
					panControl: true,
					zoomControl: false,
					mapTypeControl: false,
					scaleControl: false,
					scrollwheel: false,
					streetViewControl: false,
					rotateControl: false
				};

				var map = new google.maps.Map(document.getElementById( mapBlock ), mapOptions);

				var geocoder = new google.maps.Geocoder();

				geocoder.geocode( { 'address': mapAddress }, function(results, status) {
					if ( status == google.maps.GeocoderStatus.OK ) {
						map.setCenter( results[0].geometry.location );

						if ( mapMarker.length > 0 ){
							var mapIcon = mapMarker;
						} else {
							var mapIcon = {
							path:'M213.285,0h-0.608C139.114,0,79.268,59.826,79.268,133.361c0,48.202,21.952,111.817,65.246,189.081 c32.098,57.281,64.646,101.152,64.972,101.588c0.906,1.217,2.334,1.934,3.847,1.934c0.043,0,0.087,0,0.13-0.002 c1.561-0.043,3.002-0.842,3.868-2.143c0.321-0.486,32.637-49.287,64.517-108.976c43.03-80.563,64.848-141.624,64.848-181.482 C346.693,59.825,286.846,0,213.285,0z M274.865,136.62c0,34.124-27.761,61.884-61.885,61.884 c-34.123,0-61.884-27.761-61.884-61.884s27.761-61.884,61.884-61.884C247.104,74.736,274.865,102.497,274.865,136.62z',
								fillColor: mapMarker,
								fillOpacity: 0.9,
								scale: 0.13,
								strokeColor:'#BABBBB',
								strokeWeight: 1
							};
						}



						var marker = new google.maps.Marker({
							position: results[0].geometry.location,
							icon: mapIcon,
							map: map,
							title: mapAddress
						});

					}
					else {
						alert("Geocode was not successful for the following reason: " + status);
					};

				});

				// MAP STYLES
				map.setOptions({ styles: mapStyle });

				// MAP RESPONSIVE RESIZE
				google.maps.event.addDomListener(window, 'resize', function() {
					var center = map.getCenter();
					google.maps.event.trigger(map, "resize");
					map.setCenter(center);

				});

			};


			// LOADING MAPS
			mapLoadTrigger = true;

			$(document).on('shopify:section:load', '#shopify-section-' + mapId, function() {

				var mapInstance = $(this).find('.section_map');

				var mapAddress = mapInstance.data('map-address');
				var mapMarker = mapInstance.data('map-marker');
				var mapStyle = mapInstance.data('map-style');

				mapLoad(mapAddress, mapMarker, mapStyle);
				mapLoadTrigger = false;

			});

			if ( mapLoadTrigger = true ) {
				mapLoad(mapAddress, mapMarker, mapStyle);
			};

		});

	});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-products-carousel-left"] && !Shopify.designMode) return;
  try {
    
jQuery(document).ready(function($) {
	$('.products_carousel_mod').each(function(i) {

		var sliderId = '#' + $(this).attr('id');
		var sliderVar = $(this).attr('id');
		var sliderPagination = '#pagination_' + sliderVar.replace('products_carousel_mod_', '');

		var carouselVar = new Swiper( sliderId, {
			effect: 'slide',
			slidesPerView: 2,
			spaceBetween: 30,
			speed: 500,
			autoplayDisableOnInteraction: false,
			breakpoints: {
				576: {
					slidesPerView: 2,
				},
				768: {
					slidesPerView: 2,
				},
				992: {
					slidesPerView: 2,
				},
				1200: {
					slidesPerView: 3,
				}
			},
			pagination: {
				el: sliderPagination,
				type: 'bullets',
				clickable: true
			}
		});

	});

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-slideshow"] && !Shopify.designMode) return;
  try {
    
jQuery(document).ready(function($) {
	$('.section_slideshow').each(function(i) {
		var sliderId = '#' + $(this).attr('id');
		var sliderVar = $(this).attr('id');
		var sliderPagination = '#pagination_' + sliderVar.replace('slideshow_', '');
		var sliderPrev = '#slider_prev_' + sliderVar.replace('slideshow_', '');
		var sliderNext = '#slider_next_' + sliderVar.replace('slideshow_', '');
		var sliderEffect = $(this).data('effect');
		var sliderPagType = $(this).data('pagination');
		var sliderAutoplay = $(this).data('autoplay');
		var sliderDelayAutoplay = $(this).data('delay');

		var settings = {
			effect: sliderEffect,
			speed: 500,
			autoHeight: true,
			loop: false,
			pagination: {
				el: sliderPagination,
				clickable: true,
				dynamicBullets: false
			},
			on: {
				slideChangeTransitionStart: function () {
					AOS.refresh(true);
				},
				slideChangeTransitionEnd: function () {
					AOS.init();
				}
			},
			navigation: {
				nextEl: sliderNext,
				prevEl: sliderPrev
			}
		}
	
		if ( sliderAutoplay == true ) {
			sliderAutoplay = $(this).data('speed');
			settings.autoplay = {delay: sliderDelayAutoplay};
		}
  
		if ( sliderPagType == 'bullets' ){
			settings.pagination.type = 'bullets';
			settings.pagination.clickable = true;
		} else if ( sliderPagType == 'dynamicBullets' ){
			settings.pagination.dynamicBullets = true;
			settings.pagination.clickable = true;
		} else if ( sliderPagType == 'progressbar' ){
			settings.pagination.type = 'progressbar';
		} else if ( sliderPagType == 'fraction' ){
			settings.pagination.type = 'fraction';
		} else if ( sliderPagType == 'navigation' ){
			settings.pagination.type = false;
		} else {
			settings.pagination.type = 'bullets';
			settings.pagination.clickable = true;
		}
		
		var sliderVar = new Swiper( sliderId, settings );
	
		$(window).on('resize', function() {
			sliderVar.updateSize(); // updating swiper after loading
		});
	
		sliderVar.on('init', function (el) {
			var currentSlideIndex = sliderVar.activeIndex;
			var currentSlide = sliderVar.slides[currentSlideIndex];
			var ytPlayer = currentSlide.querySelector('iframe');
			if (ytPlayer) {
				ytPlayer.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
			}
		});
	
		/* Youtube Player event slide (next or previous) */
		sliderVar.on('slideChange', function (el) {
			$('.slide_video').each(function (i) {
				var ytPlayer = $(this).find('iframe').get(0);
				if (ytPlayer) {
					ytPlayer.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
				}
			});
			var currentSlideIndex = sliderVar.realIndex;
			var currentSlide = sliderVar.slides[currentSlideIndex];
			var ytPlayer = currentSlide.querySelector('iframe');
			if (ytPlayer) {
				ytPlayer.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
			}
		});
	
	
		/* Init Youtube Player */
		$(this).find('.player-js').each(function(i) {
			var slVideoId = '#' + $(this).attr('id');
			$(slVideoId).YTPlayer(i);
		});
  
 		/* Init Shopify design mode */
		if (Shopify.designMode) {
		  jQuery(document)
			.on('shopify:section:load', sliderAutoplay = false, sliderVar.update())
			.on('shopify:section:unload', sliderAutoplay = false, sliderVar.update())
			.on('shopify:section:select', sliderAutoplay = false, sliderVar.update())
			.on('shopify:section:deselect', sliderAutoplay = false, sliderVar.update())
			.on('shopify:section:reorder', sliderAutoplay = false, sliderVar.update())
			.on('shopify:block:select', slideshow_slide_event)
			.on('shopify:block:deselect', slideshow_slide_event);
		
		  function slideshow_slide_event(evt) {
			const block = evt.target;
			const index = Number(block.dataset.slide);
			const blockSelectedIsSwiperSlide = block.classList.contains('swiper-slide');
			if (!blockSelectedIsSwiperSlide) return;
		 
			var selectedSlideId = jQuery(block).attr("data-block-id");
			if (evt.detail.blockId === selectedSlideId) {
  				sliderVar.slideTo(index);
			}
		  }
		}
	});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-announcement-bar"]) return;
  try {
    
    (function ($) {
        $(document).ready(function() {
            var viewPeriod = '{{ section.settings.against_view_period | plus: 0 }}'; 
            var abCookie = $('#announcement-bar');
            abCookie.show();
            if ($.cookie('cookieAb') == 'closed') {
                abCookie.remove();
            }

            abCookie.find('[data-ab-cookie]').on('click', function(e) {
                e.preventDefault();
                abCookie.remove();
                $.cookie('cookieAb', 'closed', {expires: 1, path:'/'});
                $.cookie('cookieAb', "disabled", { path: '/', expires : viewPeriod });
            });
        });
    })(jQuery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-product-recommendations"]) return;
  try {
    
  
  class ProductRecommendations extends HTMLElement {
  constructor() {
  super();
  
  const handleIntersection = (entries, observer) => {
  if (!entries[0].isIntersecting) return;
  observer.unobserve(this);
  
  fetch(this.dataset.url)
  .then(response => response.text())
  .then(text => {
  const html = document.createElement('div');
  html.innerHTML = text;
  const recommendations = html.querySelector('product-recommendations');
  
  if (recommendations && recommendations.innerHTML.trim().length) {
  this.innerHTML = recommendations.innerHTML;
  }
  
  (function($){
	$('.zmz-recommend-swiper-container-js').each(function () {
		var sliderId = '#' + $(this).attr('id');
		var swiperOptions = $(this).data('options');
		var zmzCarousel = new Swiper(sliderId, swiperOptions);
	});
  })(jQuery);
  
  
  if (html.querySelector('.product_item_wrap')) {
  	this.classList.add('product-recommendations--loaded');
  }
  
  })
  .catch(e => {
  console.error(e);
  });
  }
  
  new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
  }
  }
  
  customElements.define('product-recommendations', ProductRecommendations);
 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["template-addresses"]) return;
  try {
    
jQuery(document).ready(function($) {
	// ADD NEW ADDRESS
	$('#address_add, #address_add__close').hide();

	$('#address_add__link').on('click', function(e) {
		e.preventDefault();

		$(this).fadeOut(300);
		$('#address_add__close').delay(300).fadeIn();
		$('#address_add').slideDown();
	});

	$('#address_add__close, #address_add__cancel').on('click', function(e) {
		e.preventDefault();

		$('#address_add__close').fadeOut(300);
		$('#address_add__link').delay(300).fadeIn();
		$('#address_add').slideUp();
	});


	// EDIT EXISTING ADDRESS
	$('.account_address__edit').hide();
	$('.account_address__item .link_close').hide();

	$('.link_edit').on('click', function(e) {
		e.preventDefault();

		var t = $(this).attr('href');

		$(t).find('.account_address__edit').slideDown();

		$(this).hide();

		$(t).find('.link_close').show();

		$(t).find('.link_close').on('click', function(event) {
			event.preventDefault();

			$(t).find('.account_address__edit').slideUp();

			$(this).hide();

			$(t).find('.link_edit').show();
		});

		$(t).find('.link_cancel').on('click', function(event) {
			event.preventDefault();

			$(t).find('.link_close').trigger('click');
		});

	});

});


// PROVINCES SELECTS
new Shopify.CountryProvinceSelector( 'address_country_new', 'address_province_new', { hideElement: 'address_province_container_new' } );

var customerAddresses = JSON.parse( theme.customerAddresses );

for ( i=0; i < customerAddresses.length; i++ ) {
	var addressCountry = 'address_country_' + customerAddresses[i].id;
	var addressProvince = 'address_province_' + customerAddresses[i].id;
	var addressProvinceHide = 'address_province_container_' + customerAddresses[i].id;

	new Shopify.CountryProvinceSelector( addressCountry, addressProvince, { hideElement: addressProvinceHide } );

};

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["template-login"]) return;
  try {
     
jQuery(document).ready(function($) {

	// TRACK ACCOUNT FORM 
	$('.template_customer form').each(function (){      
		$(this).on('submit', function(e){
			var formCookie = $(this).attr('id');
			$.cookie('accountForm', formCookie);
		});
	});

	var section_reset = $('#account_section__reset');

	// HIDE/SHOW FORM
	 if ( section_reset.find('.alert').length ) {
		section_reset.show();
	};


	// RESET
	$('#account_reset__link').on('click', function(e) {
		e.preventDefault();
		section_reset.fadeIn(200);
	});
	$('.account_reset__cancel').on('click', function(e) {
		e.preventDefault();
		section_reset.fadeOut(200);
	});
	if ( document.location.href.indexOf( '#recover' ) !== -1 ) {
		section_reset.show();
	};

	// VALIDATION
	$('#create_customer').formValidation();
	$('#create_customer').on('submit', function() {
		$('#password_confirmed').val( $('#password_1').val() );
	});

	$('#customer_login').formValidation();
	$('#account_section__activation form').formValidation();
	$('#account_section__reset-account form').formValidation();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["template-sidebar"]) return;
  try {
    
(function($) {
	$(window).on('load', function() {
		// LINKLIST ITEM SHOW/HIDE ELEMENT
		$('.sidebar_widget__linklist .menu_trigger').each(function(i) {
		var targetMenu = '#' + $(this).data('submenu');
	
		$(this).on('click', function(e){
				if ($(this).hasClass('active')){
					$(targetMenu).hide(300);
					$(this).removeClass('active');
				} else {
					$(targetMenu).show(300);
					$(this).addClass('active');
				};
			});
		});
	});
})(jQuery);

  } catch(e) { console.error(e); }
})();
})();
